<template>
  <div v-if="items && items.length">
    <b-card v-if="items.length" no-body>
      <b-card-header class="d-flex aling-items-center justify-content-between" :class="{'border-bottom-0 rounded-bottom': !editing}">
        <div class="d-flex align-items-center">
          {{ $t('shared.primaryCategory') }}:

          <required-symbol v-if="required"/>

          <span class="text-muted" :class="{'ml-2': $dir.ltr, 'mr-2': $dir.rtl}">
            <template v-if="!value.primaryCategoryId">({{ $t('shared.choose') }})</template>
            <template v-else>{{ primaryCategoryText }}</template>
          </span>
        </div>

        <b-btn
          v-if="value.primaryCategoryId"
          variant="primary"
          size="sm"
          :title="$t('shared.edit')"
          v-b-tooltip.hover
          @click="toggleEditing"
        >
          <font-awesome-icon icon="pencil-alt" fixed-width class="align-middle"/>
        </b-btn>
      </b-card-header>

      <b-card-body v-if="editing">
        <radio-items :all="items" :items="roots" :value="value.primaryCategoryId" @input="setPrimaryId"/>
      </b-card-body>
    </b-card>

    <b-card v-if="value.primaryCategoryId && otherItems && otherItems.length" :header="$t('shared.relatedCategories')">
      <check-items :all="otherItems" :items="otherRoots" v-model="value.categoryIds"/>
    </b-card>
  </div>
</template>

<script>
import RadioItems from './RadioItems'
import CheckItems from './CheckItems'

export default {
  name: 'CategoriesMulti',
  components: {
    RadioItems,
    CheckItems
  },
  props: {
    items: { type: Array, required: true },
    value: Object,
    required: { type: Boolean, default: false }
  },
  data () {
    return {
      editing: !this.value.primaryCategoryId
    }
  },
  computed: {
    otherItems () {
      let items = this.items

      if (this.value.primaryCategoryId)
        items = items.filter(i => i.id !== this.value.primaryCategoryId)

      return items
    },
    roots () {
      return this.items.filter(i => !i.parentId)
    },
    otherRoots () {
      return this.otherItems.filter(i => !i.parentId)
    },
    primaryCategoryText () {
      return this.items.find(i => i.id === this.value.primaryCategoryId).name
    }
  },
  watch: {
    'value.primaryCategoryId' (val) {
      this.toggleEditing()
      if (val)
        this.value.categoryIds = this.value.categoryIds.filter(i => i !== this.value.primaryCategoryId)
    }
  },
  methods: {
    toggleEditing () {
      this.editing = !this.editing
    },
    setPrimaryId (itemId) {
      this.value.primaryCategoryId = itemId
    }
  }
}
</script>
